// extracted by mini-css-extract-plugin
var _1 = "Jn3Fg";
var _2 = "lkPJJ";
export { _1 as "base", _2 as "configActions" }
